import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { AvatarsEmployeeList } from '@features/AvatarsEmloyeeList';
import { Flex, Skeleton } from '@shared/ui';
import { getEstimateInformationQuery } from '@widgets/EstimateInformation/api/hooks/getEstimateInformationQuery';
import { AddButton } from '@widgets/EstimateInformation/ui/AddButton/AddButton';
import { InfoItem } from '@widgets/EstimateInformation/ui/InfoItem';

import cls from './EstimateParticipants.module.css';

interface EstimateParticipantsProps {
    classes?: string;
    onToggleModal: (value: 'managers' | 'purchasers' | null) => void;
}

export const EstimateParticipants = ({ classes, onToggleModal }: EstimateParticipantsProps) => {
    const { data, isPending } = getEstimateInformationQuery();
    const { t } = useTranslation();

    return (
        <Flex direction="column" align="start" gap={8} className={cn(cls.participants, classes)}>
            <InfoItem label={t('EstimateParticipants.return.Flex.InfoItem.label.purchasers')}>
                {isPending ? (
                    <Skeleton width={100} height={28} border="8px" />
                ) : (
                    <Flex
                        className={cls.employeeListWrapper}
                        gap={12}
                        onClick={() => onToggleModal('purchasers')}
                    >
                        {!!data?.purchasersData.purchasers.length && (
                            <AvatarsEmployeeList employees={data?.purchasersData.purchasers} />
                        )}
                        {data?.purchasersData.canAdd && (
                            <AddButton
                                isShowLabel={!data?.purchasersData.purchasers.length}
                                onClick={() => onToggleModal('purchasers')}
                            />
                        )}
                    </Flex>
                )}
            </InfoItem>
            <InfoItem label={t('EstimateParticipants.return.Flex.InfoItem.label.managers')}>
                {isPending ? (
                    <Skeleton width={55} height={28} border="8px" />
                ) : (
                    <Flex
                        className={cls.employeeListWrapper}
                        gap={12}
                        onClick={() => onToggleModal('managers')}
                    >
                        {data?.managersData.managers.length && (
                            <AvatarsEmployeeList employees={data?.managersData.managers} />
                        )}
                        {data?.managersData.canAdd && (
                            <AddButton
                                isShowLabel={!data?.managersData.managers.length}
                                onClick={() => onToggleModal('managers')}
                            />
                        )}
                    </Flex>
                )}
            </InfoItem>
        </Flex>
    );
};
